import Cookie from '@/utils/cookie';

// let userInfo = {};
function getUserInfo() {
  return Cookie.get('userInfo');
  // if(!userInfo.wechatUserId) {
  //   userInfo = Cookie.get('userInfo');
  // }
  // return userInfo;
}

/** 应用作品url链接是否需要做处理 */
let needTransferServiceUrl = true;
function getTransferStatus() {
  return needTransferServiceUrl;
}
function setTransferStatus(status = false) {
  needTransferServiceUrl = status;
  return needTransferServiceUrl;
}

const GlobalData = {
  getUserInfo,
  /** 应用作品url链接是否需要做处理 */
  getTransferStatus,
  setTransferStatus
};

export default GlobalData;
